import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { axiosGet, axiosPost } from "../../api/Axios";

export const submitNewOrderCream = createAsyncThunk(
  "orderCream/orderNewCream",
  async (orderCream: OrderCreamFormState, { rejectWithValue }) => {
    try {
      const response = await axiosPost<
        OrderCreamFormState,
        CreateOrUpdateApisResponse
      >("/orderCream/orderNewCream", orderCream);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getMyOrdersApi = createAsyncThunk(
  "/orderCream/getMyOrders",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosGet<IDashboardOrder[]>(
        `/orderCream/getMyOrders`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const getMyLatestOrderDemoGraphics = createAsyncThunk(
  "/orderCream/getMyLatestDemoGraphics",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosGet<OrderCreamDemoGraphics>(
        `/orderCream/getMyLatestDemoGraphics`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const getMyOrderDetailsApi = createAsyncThunk(
  "/orderCream/getMyOrderDetails",
  async (query: string, { rejectWithValue }) => {
    try {
      const response = await axiosGet<UserOrderExtended | null>(
        `/orderCream/getMyOrderDetails?${query}`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getOrderByTransactionIdApi = createAsyncThunk(
  "orderCream/getOrderByTransactionId",
  async (transactionId: string, { rejectWithValue }) => {
    try {
      const response = await axiosGet<any>(
        `/orderCream/getOrderByTransactionId?transactionId=${transactionId}`
      );
      return response;
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : String(error);
      return rejectWithValue(errorMessage);
    }
  }
);

export const saveStep0Api = createAsyncThunk(
  "orderCream/saveStep0",
  async (
    data: {
      transactionId: string;
      demoGraphics?: any;
      shippingDetails?: any;
      selectedState?: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosPost<
        {
          transactionId: string;
          demoGraphics?: any;
          shippingDetails?: any;
          selectedState?: string;
        },
        any
      >("/orderCream/saveStep0", data);
      return response;
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : String(error);
      return rejectWithValue(errorMessage);
    }
  }
);

export const saveStep1Api = createAsyncThunk(
  "orderCream/saveStep1",
  async (
    data: { transactionId: string; painProfile?: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosPost<
        { transactionId: string; painProfile?: any },
        any
      >("/orderCream/saveStep1", data);
      return response;
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : String(error);
      return rejectWithValue(errorMessage);
    }
  }
);

export const saveStep2Api = createAsyncThunk(
  "orderCream/saveStep2",
  async (
    data: { transactionId: string; painFactors?: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosPost<
        { transactionId: string; painFactors?: any },
        any
      >("/orderCream/saveStep2", data);
      return response;
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : String(error);
      return rejectWithValue(errorMessage);
    }
  }
);

export const saveStep3Api = createAsyncThunk(
  "orderCream/saveStep3",
  async (
    data: { transactionId: string; painSymptoms?: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosPost<
        { transactionId: string; painSymptoms?: any },
        any
      >("/orderCream/saveStep3", data);
      return response;
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : String(error);
      return rejectWithValue(errorMessage);
    }
  }
);

export const saveStep4Api = createAsyncThunk(
  "orderCream/saveStep4",
  async (
    data: { transactionId: string; painDetails?: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosPost<
        { transactionId: string; painDetails?: any },
        any
      >("/orderCream/saveStep4", data);
      return response;
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : String(error);
      return rejectWithValue(errorMessage);
    }
  }
);

export const saveStep5Api = createAsyncThunk(
  "orderCream/saveStep5",
  async (
    data: { transactionId: string; medicalHistory?: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosPost<
        { transactionId: string; medicalHistory?: any },
        any
      >("/orderCream/saveStep5", data);
      return response;
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : String(error);
      return rejectWithValue(errorMessage);
    }
  }
);

export const saveStep6Api = createAsyncThunk(
  "orderCream/saveStep6",
  async (
    data: { transactionId: string; injuryHistory?: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosPost<
        { transactionId: string; injuryHistory?: any },
        any
      >("/orderCream/saveStep6", data);
      return response;
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : String(error);
      return rejectWithValue(errorMessage);
    }
  }
);

export const saveStep7Api = createAsyncThunk(
  "orderCream/saveStep7",
  async (
    data: { transactionId: string; medicineHistory?: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosPost<
        { transactionId: string; medicineHistory?: any },
        any
      >("/orderCream/saveStep7", data);
      return response;
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : String(error);
      return rejectWithValue(errorMessage);
    }
  }
);

export const saveStep8Api = createAsyncThunk(
  "orderCream/saveStep8",
  async (
    data: { transactionId: string; painManagement?: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosPost<
        { transactionId: string; painManagement?: any },
        any
      >("/orderCream/saveStep8", data);
      return response;
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : String(error);
      return rejectWithValue(errorMessage);
    }
  }
);

export const saveStep9Api = createAsyncThunk(
  "orderCream/saveStep9",
  async (
    data: { transactionId: string; additionalInfo?: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosPost<
        { transactionId: string; additionalInfo?: string },
        any
      >("/orderCream/saveStep9", data);
      return response;
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : String(error);
      return rejectWithValue(errorMessage);
    }
  }
);

const initialState: OrderCreamFormState = {
  selectedState: "",
  isDemoGraphicsLoading: true,
  transactionId: null,
  getStarted: {
    firstName: "",
    lastName: "",
    email: "",
  },
  demoGraphics: {
    dob: null,
    weight: "",
    heightFeet: "",
    heightInches: "",
    gender: "",
    pregnant: "",
    allergy: "",
    allAllergies: [{ id: 1, type: "", severity: "" }],
  },
  painProfile: {
    painDescriptions: [],
    painDuration: "",
    painRating: 3,
    painLocations: [],
  },
  painFactors: {
    painWorseDescriptions: [],
    physicalActivity: "",
  },
  painSymptoms: {
    // painDuration: "",
    selectedPainDescriptions: [],
    painFreq: "",
    painTrigger: "",
    painDailyImpact: "",
    showTriggerTextBox: null,
    showPainChangeTextBox: null,
    showPainSevereTimeTextBox: null,
    painChangeInfo: "",
    painSpecificTimeInDayInfo: "",
    painTriggerInfo: "",
  },
  painDetails: {
    impactedJoints: "",
    swelling: "",
    sleepInterference: "",
    burningSensation: "",
    specificStimuli: "",
  },
  medicalHistory: {
    others: [
      { id: Date.now(), type: "surgery", name: "", date: "", details: "" },
    ],
    medicalHistory: [],
  },
  injuryHistory: {
    hasOpenWound: "",
    injuryEntryChange: "",
    injuryEntries: [
      { id: Date.now(), type: "surgery", name: "", date: "", details: "" },
    ],
  },
  painManagement: {
    timing: "",
    painGoal: "",
    applicationFrequency: "",
    usedBefore: "",
    experience: "",
  },
  medicineHistory: {
    medicineDescriptions: [],
    medicineDetails: [
      {
        id: Date.now(),
        drugName: "",
        strength: "",
        form: "",
        usageFreq: "",
        duration: "",
      },
    ],
    otcMedicineHistory: [
      {
        id: Date.now(),
        drugName: "",
        strength: "",
        form: "",
        usageFreq: "",
        duration: "",
      },
    ],
    otherDetails: "",
  },
  additionalInfo: "",
  shippingDetails: {
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    address: {
      state: "",
      city: "",
      street1: "",
      street2: "",
      zipCode: "",
    },
  },
  currentStep: 0,
  isError: false,
  errors: [],
  isLoading: false,
  orders: [],
  singleOrder: null,
};
const resetErrorState = (state: OrderCreamFormState) => {
  state.isError = false;
};
const orderCreamSlice = createSlice({
  name: "orderCream",
  initialState,
  reducers: {
    handleResetCreamForm: () => initialState, // ✅ This correctly resets the state

    handleUpdateSelectedState: (state, action: PayloadAction<string>) => {
      resetErrorState(state);
      state.selectedState = action.payload;
      state.shippingDetails.address.state = action.payload;
    },
    handleGetStartedFormFields: (
      state,
      action: PayloadAction<{ key: keyof OrderCreamGetStarted; value: string }>
    ) => {
      // resetErrorState(state);
      const { key, value } = action.payload;
      state.getStarted[key] = value;
    },
    handleUpdatePainDetails: (
      state,
      action: PayloadAction<{ key: keyof OrderCreamPainDetails; value: string }>
    ) => {
      resetErrorState(state);
      const { key, value } = action.payload;
      state.painDetails[key] = value;
    },
    handleUpdatePainManagement: (
      state,
      action: PayloadAction<{
        key: keyof OrderCreamPainManagement;
        value: string;
      }>
    ) => {
      resetErrorState(state);
      const { key, value } = action.payload;
      state.painManagement[key] = value;
    },
    handleGoToNextStep: (state) => {
      // resetErrorState(state);
      state.currentStep = state.currentStep + 1;
    },
    handleGoBack: (state) => {
      // resetErrorState(state);
      state.currentStep = state.currentStep - 1;
    },
    handleUpdateErrorsOfOrderCreamForm(
      state,
      action: PayloadAction<IUpdateErrors>
    ) {
      state.isError = action.payload.isError;
      state.errors = action.payload.errors;
    },
    handleUpdateDemoGraphic: (
      state,
      action: PayloadAction<{
        key: keyof OrderCreamDemoGraphics;
        value: string;
      }>
    ) => {
      // resetErrorState(state);
      const { key, value } = action.payload;
      if (key !== "allAllergies") {
        state.demoGraphics[key] = value;
      }
    },
    handleUpdateDemoGraphicsAllergies: (
      state,
      action: PayloadAction<any[]>
    ) => {
      state.demoGraphics.allAllergies = action.payload;
    },
    updateUserPainProfileRating: (state, action: PayloadAction<number>) => {
      resetErrorState(state);
      const painRating = action.payload;
      state.painProfile.painRating = painRating;
    },
    handleUpdatePainProfileDuration: (state, action: PayloadAction<string>) => {
      resetErrorState(state);
      state.painProfile.painDuration = action.payload;
    },
    handlePainDescriptionChange: (state, action: PayloadAction<string>) => {
      resetErrorState(state);
      const painType = action.payload;
      const currentIndex = state.painProfile.painDescriptions.indexOf(painType);

      if (currentIndex === -1) {
        // If painType is not in the array, add it only if we haven't reached the maximum of 3
        if (state.painProfile.painDescriptions.length < 3) {
          state.painProfile.painDescriptions.push(painType);
        }
      } else {
        // If painType is in the array, remove it
        state.painProfile.painDescriptions.splice(currentIndex, 1);
      }
    },
    handleUpdatePainFactorActivity: (state, action: PayloadAction<string>) => {
      resetErrorState(state);
      state.painFactors.physicalActivity = action.payload;
    },
    handleUpdatePainFactorWorse: (state, action: PayloadAction<string>) => {
      resetErrorState(state);
      const painType = action.payload;
      const currentIndex =
        state.painFactors.painWorseDescriptions.indexOf(painType);

      if (currentIndex === -1) {
        // If painType is not in the array, add it
        state.painFactors.painWorseDescriptions.push(painType);
      } else {
        // If painType is in the array, remove it
        state.painFactors.painWorseDescriptions.splice(currentIndex, 1);
      }
    },

    // * pain symptoms
    // handleUpdatePainSymptomsDuration: (
    //   state,
    //   action: PayloadAction<string>
    // ) => {
    //   resetErrorState(state);
    //   state.painSymptoms.painDuration = action.payload;
    // },

    handleUpdatePainSymptomsSelectedPainDescriptions: (
      state,
      action: PayloadAction<string>
    ) => {
      resetErrorState(state);
      const description = action.payload;
      const currentIndex =
        state.painSymptoms.selectedPainDescriptions.indexOf(description);

      if (currentIndex === -1) {
        state.painSymptoms.selectedPainDescriptions.push(description);
      } else {
        state.painSymptoms.selectedPainDescriptions.splice(currentIndex, 1);
      }
    },

    handleUpdatePainSymptomsFreq: (state, action: PayloadAction<string>) => {
      resetErrorState(state);
      state.painSymptoms.painFreq = action.payload;
    },

    handleUpdatePainSymptomsTrigger: (state, action: PayloadAction<string>) => {
      resetErrorState(state);
      state.painSymptoms.painTrigger = action.payload;
    },

    handleUpdatePainSymptomsDailyImpact: (
      state,
      action: PayloadAction<string>
    ) => {
      resetErrorState(state);
      state.painSymptoms.painDailyImpact = action.payload;
    },

    handleTogglePainSymptomsShowTriggerTextBox: (
      state,
      action: PayloadAction<boolean>
    ) => {
      resetErrorState(state);
      state.painSymptoms.showTriggerTextBox = action.payload;
    },

    handleTogglePainSymptomsShowPainChangeTextBox: (
      state,
      action: PayloadAction<boolean>
    ) => {
      resetErrorState(state);
      state.painSymptoms.showPainChangeTextBox = action.payload;
    },

    handleTogglePainSymptomsShowPainSevereTimeTextBox: (
      state,
      action: PayloadAction<boolean>
    ) => {
      resetErrorState(state);
      state.painSymptoms.showPainSevereTimeTextBox = action.payload;
    },
    handleUpdatePainSymptomsChangeInfo: (
      state,
      action: PayloadAction<string>
    ) => {
      resetErrorState(state);
      state.painSymptoms.painChangeInfo = action.payload;
    },

    handleUpdatePainSymptomsSpecificTimeInDayInfo: (
      state,
      action: PayloadAction<string>
    ) => {
      resetErrorState(state);
      state.painSymptoms.painSpecificTimeInDayInfo = action.payload;
    },

    handleUpdatePainSymptomsTriggerInfo: (
      state,
      action: PayloadAction<string>
    ) => {
      resetErrorState(state);
      state.painSymptoms.painTriggerInfo = action.payload;
    },
    handleUpdateMedicalHistory: (
      state,
      action: PayloadAction<OrderCreamMedicalHistory>
    ) => {
      state.medicalHistory = action.payload;
      state.currentStep = state.currentStep + 1;
    },

    // ! pain symptoms end
    handleUpdateInjuryHistoryOpenWound: (
      state,
      action: PayloadAction<string>
    ) => {
      resetErrorState(state);
      state.injuryHistory.hasOpenWound = action.payload;
    },
    handleUpdateInjuryHistory: (
      state,
      action: PayloadAction<InjuryEntry[]>
    ) => {
      resetErrorState(state);
      state.injuryHistory.injuryEntries = action.payload;
    },
    handleUpdateMedicineHistory: (
      state,
      action: PayloadAction<OrderCreamMedicineHistory>
    ) => {
      resetErrorState(state);
      state.medicineHistory = action.payload;
      state.currentStep = state.currentStep + 1;
    },
    handleUpdateAdditionalInfo: (state, action: PayloadAction<string>) => {
      resetErrorState(state);
      state.additionalInfo = action.payload;
    },
    handleUpdateIfHasInjury: (state, action: PayloadAction<string>) => {
      resetErrorState(state);
      state.injuryHistory.injuryEntryChange = action.payload;
    },
    handleUpdateOrderCreamLoadingState: (
      state,
      action: PayloadAction<boolean>
    ) => {
      resetErrorState(state);
      state.isLoading = action.payload;
    },
    handleUpdateOrderCreamPainLocations(
      state,
      action: PayloadAction<string[]>
    ) {
      resetErrorState(state);
      state.painProfile.painLocations = action.payload;
    },
    handleUpdateShippingDetails(
      state,
      action: PayloadAction<OrderCreamShippingDetails>
    ) {
      state.shippingDetails = action.payload;
    },
    handleUpdateTransactionId(state, action: PayloadAction<string>) {
      state.transactionId = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getMyOrdersApi.pending, (state) => {
        state.isLoading = true;
        state.isError = false; // Reset error
      })
      .addCase(getMyOrdersApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.orders = action.payload;
      })
      .addCase(getMyOrdersApi.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true; // Handle error message
        state.errors = [action.payload as string];
      })
      .addCase(getMyOrderDetailsApi.pending, (state) => {
        state.isLoading = true;
        state.isError = false; // Reset error
      })
      .addCase(getMyOrderDetailsApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.singleOrder = action.payload;
      })
      .addCase(getMyOrderDetailsApi.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true; // Handle error message
        state.errors = [action.payload as string];
      })
      .addCase(getMyLatestOrderDemoGraphics.pending, (state) => {
        state.isLoading = true;
        state.isDemoGraphicsLoading = true;
        state.isError = false; // Reset error
      })
      .addCase(getMyLatestOrderDemoGraphics.fulfilled, (state, action) => {
        state.isLoading = false;
        state.demoGraphics = action.payload;
        state.isDemoGraphicsLoading = false;
      })
      .addCase(getMyLatestOrderDemoGraphics.rejected, (state, action) => {
        state.isDemoGraphicsLoading = false;
        state.isLoading = false;
        // state.isError = true; // Handle error message
        // state.errors = [action.payload as string];
      })
      .addCase(getOrderByTransactionIdApi.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(getOrderByTransactionIdApi.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload) {
          // Populate state with order data
          const order = action.payload;
          if (order.demoGraphics) state.demoGraphics = order.demoGraphics;
          if (order.painProfile) state.painProfile = order.painProfile;
          if (order.painFactors) state.painFactors = order.painFactors;
          if (order.painSymptoms) state.painSymptoms = order.painSymptoms;
          if (order.painDetails) state.painDetails = order.painDetails;
          if (order.medicalHistory) state.medicalHistory = order.medicalHistory;
          if (order.injuryHistory) state.injuryHistory = order.injuryHistory;
          if (order.medicineHistory)
            state.medicineHistory = order.medicineHistory;
          if (order.painManagement) state.painManagement = order.painManagement;
          if (order.additionalInfo !== undefined)
            state.additionalInfo = order.additionalInfo;
          if (order.currentStep !== undefined)
            state.currentStep = order.currentStep;
          if (order.shippingDetails)
            state.shippingDetails = order.shippingDetails;
          if (order.selectedState) state.selectedState = order.selectedState;
        }
      })
      .addCase(getOrderByTransactionIdApi.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errors = [action.payload as string];
      })
      .addCase(saveStep0Api.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(saveStep0Api.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload?.currentStep !== undefined) {
          state.currentStep = action.payload.currentStep;
        }
      })
      .addCase(saveStep0Api.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errors = [action.payload as string];
      })
      .addCase(saveStep1Api.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(saveStep1Api.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload?.currentStep !== undefined) {
          state.currentStep = action.payload.currentStep;
        }
      })
      .addCase(saveStep1Api.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errors = [action.payload as string];
      })
      .addCase(saveStep2Api.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(saveStep2Api.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload?.currentStep !== undefined) {
          state.currentStep = action.payload.currentStep;
        }
      })
      .addCase(saveStep2Api.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errors = [action.payload as string];
      })
      .addCase(saveStep3Api.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(saveStep3Api.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload?.currentStep !== undefined) {
          state.currentStep = action.payload.currentStep;
        }
      })
      .addCase(saveStep3Api.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errors = [action.payload as string];
      })
      .addCase(saveStep4Api.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(saveStep4Api.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload?.currentStep !== undefined) {
          state.currentStep = action.payload.currentStep;
        }
      })
      .addCase(saveStep4Api.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errors = [action.payload as string];
      });
  },
});

// Export actions and reducer
export const {
  handleUpdateSelectedState,
  handleUpdatePainDetails,
  handleGetStartedFormFields,
  handleGoToNextStep,
  handleGoBack,
  handleUpdateErrorsOfOrderCreamForm,
  handleUpdateDemoGraphic,
  handleUpdateDemoGraphicsAllergies,
  updateUserPainProfileRating,
  handleUpdatePainProfileDuration,
  handlePainDescriptionChange,
  handleUpdatePainFactorActivity,
  handleUpdatePainFactorWorse,
  //symptoms
  // handleUpdatePainSymptomsDuration,
  handleUpdatePainSymptomsSelectedPainDescriptions,
  handleUpdatePainSymptomsFreq,
  handleUpdatePainSymptomsTrigger,
  handleUpdatePainSymptomsDailyImpact,
  handleTogglePainSymptomsShowTriggerTextBox,
  handleTogglePainSymptomsShowPainChangeTextBox,
  handleTogglePainSymptomsShowPainSevereTimeTextBox,
  handleUpdatePainSymptomsChangeInfo,
  handleUpdatePainSymptomsSpecificTimeInDayInfo,
  handleUpdatePainSymptomsTriggerInfo,

  //symptoms end
  handleUpdateMedicalHistory,
  handleUpdateInjuryHistoryOpenWound,
  handleUpdateInjuryHistory,
  handleUpdatePainManagement,
  handleUpdateAdditionalInfo,
  handleUpdateMedicineHistory,
  handleUpdateIfHasInjury,
  handleUpdateOrderCreamLoadingState,
  handleUpdateOrderCreamPainLocations,
  handleUpdateShippingDetails,
  //reset
  handleResetCreamForm,
  handleUpdateTransactionId,
} = orderCreamSlice.actions;
export default orderCreamSlice.reducer;
